import React from 'react';
import { cn } from '../../lib/cn';

const Kbd = React.forwardRef(({ className, children, ...props }, ref) => (
  <kbd
    ref={ref}
    className={cn(
      'text-foreground border-border bg-background flex h-5 items-center justify-center rounded-md border px-1.5 font-mono text-[10px] font-semibold',
      className
    )}
    {...props}
  >
    {children}
  </kbd>
));
Kbd.displayName = 'Kbd';

export { Kbd };
